// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text__Qn5xlTNptY{margin-top:var(--dixa-size-spacer-300)}`, "",{"version":3,"sources":["webpack://./src/assets/components/shared/tableLoadingRow/tableLoadingRow.module.scss"],"names":[],"mappings":"AAEA,kBACE,sCAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.text {\n  margin-top: var(--dixa-size-spacer-300);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `text__Qn5xlTNptY`
};
export default ___CSS_LOADER_EXPORT___;
